<template>
  <div id="app">
    <router-view v-if="webConfig"/>
  </div>
</template>

<script>
import jwt_decode from "jwt-decode";
import {getFindAll} from './request/get'
const rate= window.innerWidth/1400;
export default {
  name: "app",
      metaInfo: {
        title:" 职业发展规划工作项目组",
        meta: [
          { name:'viewport', content:
          `width=device-width, user-scalable=yes, initial-scale=${rate}, maximum-scale=${10}, minimum-scale=${rate}`}
      ]
    },
  created() {
    if (localStorage.eleToken) {
      const decode = jwt_decode(localStorage.eleToken);
      this.$store.dispatch("setIsAutnenticated", !this.isEmpty(decode));
      this.$store.dispatch("setUser", decode);
    }
    this.getFindAll()
  },
  data(){
    return  {
      webConfig:null
    }
  },
  mounted(){
    if(!this.$IsPhone&&this.$route.name!=='CreateGrCert'&&this.$route.name!=='CreateQyCert')
    {
      const rate= window.innerWidth/1920;
      $("html").css("zoom",rate);
      window.addEventListener('resize', function() {
        let ratenew= window.innerWidth/1920;
        if(ratenew>rate)
        {
          $("html").css("zoom",ratenew)
        }
        
      })
    }
    
    
  },
  methods: {
    isEmpty(value) {
      return (
        value === undefined ||
        value === null ||
        (typeof value === "object" && Object.keys(value).length === 0) ||
        (typeof value === "string" && value.trim().length === 0)
      );
    },
    async getFindAll() {
      let result = await getFindAll();
      result = result.data[0] || null;
      this.webConfig = result;
      this.$store.dispatch("SET_WEBCONFIG", result);
    },
  }
};
</script>


<style>
html,
body,
#app {
  width: 100%;
  height: 100%;
}
</style>
